import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import TwoDDountChart from 'src/Chart/TwoDDountChart';
import InfoHeader from '../component/InfoHeader';
import TlInfoCard from '../component/TlInfoCard';
import LeaveVsPlannedCard from '../component/LeaveVsPlannedCrad';
import LeaveVsPlannedScore from '../component/LeaveVsPlannedScore';
import PercentageWorkingHours from '../component/PercentageWorkingHours';
import PercentageProductivityByDepart from '../component/PercentageProductivityByDepart';
import PresentAbsentDataTable from '../component/PresentAbsentDataTable';
import LeavesData from '../component/LeavesData';
import dashboardDataSelector from 'src/core/resource/dashboard/dashboard.Selector.js';
import { connect } from 'react-redux';
import SideBar from '../component/SideBar';
import dashboardDataAction from 'src/core/resource/dashboard/dashboardData.Action.js';
import EmployeeList from '../component/EmployeeList';

const TeamWiseDashboard = ({
  tldashboardRequestAction,
  tlDashboardData,
  startDate,
  endDate,
  tlId,
  showEmployeeList,
  filterEmployeeList,
  setTab,
  setEmpId,
}) => {
  useEffect(() => {
    tldashboardRequestAction({
      emp_user_id: tlId,
      startDate: startDate,
      endDate: endDate,
    });
  }, []);

  return (
    <div>
      {!showEmployeeList ? (
        <>
          <TlInfoCard
            teamSummary={tlDashboardData?.employeegross}
            managerInfo={tlDashboardData?.Manager}
            teamMember={tlDashboardData?.allMember}
          />
          <div className="row">
            <LeaveVsPlannedCard
              leavevsplannedleavedata={tlDashboardData?.plannedLeave}
            />
            <LeaveVsPlannedScore />
          </div>
          <div className="row">
            <PercentageWorkingHours />

            <PercentageProductivityByDepart />
          </div>

          <PresentAbsentDataTable
            presentabsentdata={tlDashboardData?.TotalPresentAbsents}
          />
          <LeavesData allLeaveDetails={tlDashboardData?.getLeavedetail} />
          <div className="row">
            <div className="col-md-5 mb-3 pe-md-1">
              <div className="cardBox h-100">
                <h3 className="fs-6 fw-bold mb-3">Exceeding Corrections</h3>
                <div className="row">
                  <div className="col">
                    <div className="position-relative">
                      <div id="correctionChart" style={{ height: '180px' }}>
                        <TwoDDountChart />
                      </div>
                      <strong className="innerScore text-primary">
                        {parseInt(
                          tlDashboardData?.ExceedingCorrections
                            ?.ExceedingCorrection
                            ? tlDashboardData?.ExceedingCorrections
                                ?.ExceedingCorrection
                            : '0',
                        )}
                        %
                      </strong>
                    </div>
                    <span className="fs-8 text-center d-block fw-medium text-secondary">
                      % Of Employees exceeding the limit of corrections
                    </span>
                  </div>
                  <div className="col">
                    <div className="versusTxt flex-wrap border-0">
                      <strong className="w-100 mb-4">
                        <b className="text-orange">
                          {parseInt(
                            tlDashboardData?.ExceedingCorrections
                              ?.OverallCorrections
                              ? tlDashboardData?.ExceedingCorrections
                                  ?.OverallCorrections
                              : '0',
                          )}
                        </b>
                        Overall <br /> Corrections
                      </strong>
                      <strong className="w-100">
                        <b className="text-orange">4</b>
                        Monthly <br /> correction limit
                      </strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-7 mb-3">
              <div className="cardBox h-100">
                <h3 className="fs-6 fw-bold mb-3">Brakes and Approvals</h3>
                <div className="row mb-4">
                  <div className="col text-center">
                    <div className="position-relative">
                      <div id="exceedBrakeChart" style={{ height: '110px' }}>
                        <TwoDDountChart
                          graphData={[
                            parseInt(
                              tlDashboardData?.BrakesApprovals
                                ?.ExceedBrakesPercentage
                                ? tlDashboardData?.BrakesApprovals
                                    ?.ExceedBrakesPercentage
                                : '0',
                            ),
                            100 -
                              parseInt(
                                tlDashboardData?.BrakesApprovals
                                  ?.ExceedBrakesPercentage
                                  ? tlDashboardData?.BrakesApprovals
                                      ?.ExceedBrakesPercentage
                                  : '0',
                              ),
                          ]}
                          label={['achived', 'not achived']}
                          labemName=""
                          labelColor={[
                            'rgb(254, 123, 30)',
                            'rgb(245, 245, 245)',
                          ]}
                          borderWidth={10}
                        />
                      </div>
                      <strong className="innerScore text-orange fs-6">
                        {parseInt(
                          tlDashboardData?.BrakesApprovals
                            ?.ExceedBrakesPercentage
                            ? tlDashboardData?.BrakesApprovals
                                ?.ExceedBrakesPercentage
                            : '0',
                        )}
                        %
                      </strong>
                    </div>
                    <span className="text-primary fw-medium">Exceed Brake</span>
                  </div>
                  <div className="col text-center">
                    <div className="position-relative">
                      <div
                        id="CorrectionApprovedChart"
                        style={{ height: '110px' }}
                      >
                        <TwoDDountChart
                          graphData={[
                            parseInt(
                              tlDashboardData?.BrakesApprovals
                                ?.CorrectionApproved
                                ? tlDashboardData?.BrakesApprovals
                                    ?.CorrectionApproved
                                : '0',
                            ),
                            100 -
                              parseInt(
                                tlDashboardData?.BrakesApprovals
                                  ?.CorrectionApproved
                                  ? tlDashboardData?.BrakesApprovals
                                      ?.CorrectionApproved
                                  : '0',
                              ),
                          ]}
                          label={['achived', 'not achived']}
                          labemName=""
                          labelColor={[
                            'rgb(254, 123, 30)',
                            'rgb(245, 245, 245)',
                          ]}
                          borderWidth={10}
                        />
                      </div>
                      <strong className="innerScore text-orange fs-6">
                        {parseInt(
                          tlDashboardData?.BrakesApprovals?.CorrectionApproved
                            ? tlDashboardData?.BrakesApprovals
                                ?.CorrectionApproved
                            : '0',
                        )}
                        %
                      </strong>
                    </div>
                    <span className="text-primary fw-medium">
                      Correction Approved
                    </span>
                  </div>
                  <div className="col text-center">
                    <div className="position-relative">
                      <div id="compOffChart" style={{ height: '110px' }}>
                        <TwoDDountChart
                          graphData={[
                            parseInt(
                              tlDashboardData?.BrakesApprovals?.TotalCoff
                                ? tlDashboardData?.BrakesApprovals?.TotalCoff
                                : '0',
                            ),
                            100 -
                              parseInt(
                                tlDashboardData?.BrakesApprovals?.TotalCoff
                                  ? tlDashboardData?.BrakesApprovals?.TotalCoff
                                  : '0',
                              ),
                          ]}
                          label={['achived', 'not achived']}
                          labemName=""
                          labelColor={[
                            'rgb(254, 123, 30)',
                            'rgb(245, 245, 245)',
                          ]}
                          borderWidth={10}
                        />
                      </div>
                      <strong className="innerScore text-orange fs-6">
                        {parseInt(
                          tlDashboardData?.BrakesApprovals?.TotalCoff
                            ? tlDashboardData?.BrakesApprovals?.TotalCoff
                            : '0',
                        )}
                        %
                      </strong>
                    </div>
                    <span className="text-primary fw-medium">
                      Comp-off Appproved
                    </span>
                  </div>
                </div>
                <div className="text-end">
                  <a href="/" className="btn btn-primary">
                    Download Report
                  </a>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div>
            <TlInfoCard
              teamSummary={tlDashboardData?.employeegross}
              managerInfo={tlDashboardData?.Manager}
              teamMember={tlDashboardData?.allMember}
            />
          </div>
          <EmployeeList
            filterEmployeeList={filterEmployeeList}
            setTab={setTab}
            setEmpId={setEmpId}
          />
        </>
      )}
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  tldashboardRequestAction: data =>
    dispatch(dashboardDataAction.tldashboardDataRequestAction(data)),
});
export default connect(null, mapDispatchToProps)(TeamWiseDashboard);
